module.exports = __webpack_public_path__ + "img/img3.64e66ec2.svg";